export const CardVerificationRoutes = [
  {
    path: 'cardVerification',
    lazy: () => import('./CardVerificationPage'),
  },
] as const
